export default __webpack_public_path__ + "222a4bdce93a1b7d49237e810a042f46.png";